import Model from "./Model";
import * as moment from 'moment';
import PaymentMethod from "./PaymentMethod";
class PaymentData extends Model {
  beneficiary_name: any = '';
  branch_code: any = '';
  currency: any = '';
  bank_name: any = '';
  bank_account: any = '';
  bank_code: any = '';
  email: any = '';
  constructor(options) {
    super();
    this.bind(options);
  }
  getKey(key) {
    return key.split('_').map(s => {
      return s[0].toUpperCase() + s.substring(1);
    }).join(' ');
  }
}
class PaymentDetail extends Model {
  constructor(options) {
    super();
    (this as any).payment_method = d => {
      return new PaymentMethod(d.data);
    };
    (this as any).data = d => {
      return new PaymentData(d);
    };
    this.bind(options);
  }
}

export default PaymentDetail;
